<template>
  <div class="d-flex justify-center align-center flex-column full-height">
    <div >
      <img :src="alreadyExpired" alt="error icon">
    </div>
    <p class="email-confirmation-already-expired">{{ $t("overview.alreadyExpired") }}</p>
    <p class="email-link-date-confirmation">{{ $t("overview.linkIsExpired")}}</p>
    <p class="email-link-date"> {{ $t("overview.confirmAccountActivation")}}</p>
    <div>
      <div v-if="!showLoginButton" @click="resendEmail">
        <auth-button  class="Send-new-link">
          {{ $t("overview.SendNewLink")}}
        </auth-button>
      </div>
      <div v-else @click="goToLoginPage">
        <auth-button class="Send-new-link">
          {{ $t('auth.login.login') }}
        </auth-button>
      </div>
      <div class='support-block pt-5' v-if="showSupportBlock">
        <div class="subheading d-flex justify-center flex-column text-center notice-restrictions">
          <p style='margin-bottom: 0'>{{ $t("overview.lotSendingLetters") }}</p>
          <p>{{ $t("overview.contactWithSupport") }}</p>
          <p v-if="$i18n.locale === 'ru'">{{ $t("overview.contactSupport") }}</p>
        </div>
        <v-card-actions class="d-flex justify-center text-center" @click="showChat">
          <v-card-text color="primary" class='pt-3'>
            <span class='link-send-email-write-to-support'>
              {{ $t("overview.writeToSupport") }}
            </span>
          </v-card-text>
        </v-card-actions>
      </div>
    </div>
  </div>
</template>

<script>

import AuthButton from '@/components/auth/components/AuthButton.vue'

export default {
  name: 'ExpiredLinkHandler',

  components: { AuthButton },

  data() {
    return {
      alreadyExpired: require('@/assets/auth/already_expired.svg'),
      showLoginButton: false,
      email: '',
      showSupportBlock: false,
      count: parseInt(localStorage.getItem('requestEmailVerificationCount'), 10) || 0
    }
  },

  created() {
    const queryKeys = Object.keys(this.$route.query)

    if (queryKeys.includes('username')) {
      this.email = this.$route.query.username;
    } else {
      this.$router.push({ name: 'Login' })
    }

    const confirmToken = localStorage.getItem('confirmToken')
    if (!confirmToken){
      this.showLoginButton = true
    }
  },

  methods: {
    async resendEmail() {
      try {
        const accessToken = localStorage.getItem('confirmToken')

        if (accessToken) {
          this.count++

          localStorage.setItem('requestEmailVerificationCount', this.count)

          await this.$store.dispatch('auth/sendEmailVerificationNotification', { accessToken, count: this.count })
          await this.$router.push( {name: 'ConfirmEmail', query: { username: this.email }} )
        } else {
          this.showLoginButton = true
        }
      } catch (error) {
        console.error('Error sending email verification notification:', error)
        if (error.response && error.response.status === 429) {
          this.showSupportBlock = true;
        }
      }
    },
    goToLoginPage() {
      this.$router.push({ name: 'Login' })
    },
    showChat() {
      window.Intercom('show')
    },
  },
};
</script>

<style scoped lang="scss">
.full-height {
  height: 100vh;
}

.email-confirmation-already-expired{
  color: var(--text-text-primary, #19181A);
  text-align: center;
  font-family: Roboto, sans-serif;
  font-size: 30px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px;
  margin-top: 46px;
}

.email-link-date-confirmation {
  margin-bottom: 0;
}

.email-link-date,
.email-link-date-confirmation {
  color: var(--text-text-primary, #19181A);
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

.notice-restrictions {
  color: var(--text-text-error, #B71921);
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

.link-send-email-write-to-support {
  color: var(--link-link-primary-text-default, #B645EE);
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  cursor: pointer;
  border-bottom: 1px solid #F4E3FD;
}

.Send-new-link {
  color: var(--White, #FFF);
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  margin-top: 32px;
  padding: 0 32px!important;
}
</style>
